<template>
    <q-layout view="lHh Lpr lFf">
        <q-header v-if="showHeader" bordered>
            <q-toolbar>
                <q-btn flat
                       dense
                       round
                       class="mobile-hide"
                       aria-label="Menu"
                       icon="fas fa-bars"
                       @click="leftDrawerOpen = !leftDrawerOpen" />
                <q-img fit="scale-down"
                       :style="{ maxHeight: '51px', margin: '5px 0' }"
                       no-spinner
                       loading="eager"
                       src="./assets/logo.png" />
            </q-toolbar>
        </q-header>

        <q-drawer v-model="leftDrawerOpen" show-if-above bordered class="bg-grey-2">
            <q-list>
                <q-item v-for="menu in menus"
                        :key="menu.key"
                        clickable
                        tag="a"
                        :to="menu.to">
                    <q-item-section avatar>
                        <q-icon :name="`img:/icons/${menu.key}.svg`" />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>{{ $t(menu.label) }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </q-drawer>

        <q-page-container>
            <router-view />
        </q-page-container>

        <q-footer v-show="showFooter" bordered class="mobile-only bg-white">
            <q-btn-group spread>
                <q-btn v-for="menu in menus"
                       :key="menu.key"
                       flat
                       :to="menu.to"
                       :name="menu.key"
                       text-color="primary"
                       class="q-py-sm q-px-none items-center">
                    <div class="column items-center">
                        <!-- <q-icon :name="`img:/icons/${menu.key}.svg`" /> -->
                        <icon :name="menu.key" width="2rem" height="2rem" color="#000000" />
                        <div class="text-center text-caption text-no-wrap">
                            {{ $t(menu.label) }}
                        </div>
                    </div>
                </q-btn>
            </q-btn-group>
        </q-footer>

    </q-layout>
</template>

<script>
    import { ref } from 'vue';

    export default {
        name: 'Layout',
        setup() {
            return {
                leftDrawerOpen: ref(false),
            };
        },
        data() {
            return {
                isMobile: false,
                showFooter: true,
                menus: [
                    {
                        key: 'booking',
                        to: { name: 'BookingIndex' },
                        label: 'booking.menuTitle',
                    },
                    {
                        key: 'checkin',
                        to: { name: 'TradeIndex' },
                        label: 'checkIn.menuTitle',
                    },
                    // {
                    //   key: 'service',
                    //   to: { name: 'ServiceIndex' },
                    //   label: 'service.menuTitle',
                    // },
                    {
                        key: 'account',
                        to: { name: 'AccountIndex' },
                        label: 'account.menuTitle',
                    },
                    {
                        key: 'more',
                        to: { name: 'MoreIndex' },
                        label: 'more.menuTitle',
                    },
                ],
            };
        },
        created() {
            this.detectDeviceType();
        },
        methods: {
            detectDeviceType() {
                //console.log('12345');
                if(this.$sharedMethod()){
                    this.isMobile = true;
                    this.showFooter = false;
                }
            }
        },
        computed: {
            showHeader() {
                if (this.isMobile == true) {
                    return false;
                }

                const excludedRoutes = ['Register', 'Login', 'Token'];
                return excludedRoutes.includes(this.$route.name) ? false : true;
            },
        },
    };
</script>
